<template>
    <list-page-shell title="疑难单">
        <order-workbench
            :extra-query-params="{ status_color: 'red' }"
            :show-create-button="false"
            :show-title="false"
        />
    </list-page-shell>
</template>

<script>
import ListPageShell from '../components/ListPageShell.vue';
import OrderWorkbench from '../components/OrderWorkbench.vue';

export default {
    name: 'DifficultList',
    components: {
        ListPageShell: ListPageShell,
        OrderWorkbench: OrderWorkbench
    }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/views/DifficultList.vue